import React, { useState, useEffect, createRef } from "react";
import ImageChatScreen from "../../images/chat-screen.png";
import lottie from 'lottie-web';
import InView from 'react-intersection-observer';
import animation from '../../icons/svg_animations/Patients-Journey-Path/PatientsJourneyPath.json';
import animation1 from '../../icons/svg_animations/Patients-Journey-Cycle/PatientsJourneyCycle.json';
import LazyLoad from 'react-lazyload';
//import AOS from 'aos';

import 'aos/dist/aos.css'
export default function Process() {
  const [isVisible, setisVisible] = useState({ first: false, second: false });
  let animationContainer = createRef();
  let animationContainer1 = createRef();
  let AOS;

  useEffect(() => {
    const AOS = require("aos");
    AOS.init({
      once: true,
    });

    const anim = lottie.loadAnimation({
      container: animationContainer.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animation
    });

  }, []);

  useEffect(() => {
    if (AOS) {
      AOS.refresh();
    }
  });

  const variants = {
    hidden: {
      scale: 0,
      opacity: 0,
      x: -200
    },
    show: {
      x: 0,
      scale: 1,
      opacity: 1,
      transition: {
        damping: 40,
        stiffness: 500
      }
    }
  };

  return (
    <div className="section-gap-small po-process">
      <div className="po-process-inner section-gap">
        <div className="container">
          <div className="po-process-image">
            <InView as="div" className="Patients-Journey-Cycle" onChange={(inView) => {
                    if (inView && animation1)
                      lottie.loadAnimation({
                        container: animationContainer1.current,
                        renderer: "svg",
                        loop: false,
                        autoplay: true,
                        animationData: animation1
                      });
                  }} triggerOnce={true}>
                  <div ref={animationContainer1} />
            </InView>
            <div className="Patients-Journey-Path" ref={animationContainer} />
          </div>
          <div className="po-process-content">
              <h3>Untangling the patients’ and providers’ journey</h3>
              <p>We identified technological, emotional, and educational challenges in the prevention and treatment of MSK injuries. After extensive research and multiple sessions with stakeholders, the Rapidops team came up with a deep understanding of patients’ and doctors’ pain points, journeys, and expectations. We found that patients' behaviors can be improved with continuous education, engagement, and personalized connection with their providers in a friendly setting. On the other hand, while providers wanted to help patients personally, they had to be productive to help more patients; hence, they could not manually engage with each patient.</p>
    
              <p>With insights into what the end-user needs and PhysioOutcomes wants to achieve, we defined the platform opportunity, user expectations, and overall execution strategy. </p>
          </div>
        </div>
      </div>
      <div className="chat-screen section-gap-large">
        <div className="container">
        <div data-aos="zoom-in" data-aos-delay="200"><LazyLoad offset={700}><img src={ImageChatScreen} title=" Patient monitoring software" alt=" Patient monitoring software" /></LazyLoad></div>
      </div>
    </div>
    <div className="chat-content section-gap-small">
        <div className="container-small">
            <h3>Improving patient recovery, one conversation at a time</h3>
            <p>The target users of this platform ranged from GenZ to Babyboomers. It was clear that the user experience was imperative to the platform’s success. We concluded that smartphone users of all ages were hooked to messaging apps, and we decided to bank on this friendly and familiar habit. So, we turned the recovery process into an engaging chat conversation between patients and doctors. We planned to develop a native mobile app for patients and providers to exchange messages, videos, images, documents, and reminders. The providers can keep patients on track with readymade, automated, and personalized content for each unique condition and recovery path.</p>

            <p>The MVP prototype allowed us to validate every user touchpoint, discover new requirements, and design the platform that enabled "right" experiences and allowed PhysioOutcomes to scale as a business.</p>
        </div>
      </div>
    </div>
  );
}
